<div class="container-fluid">
  <app-main-navbar></app-main-navbar>
  <div class="row r2">
    <div class="col-2">
      <app-results-sidebar></app-results-sidebar>
    </div>
    <div class="col results-main-body">
      <div class="row app-tab">
        <app-tab></app-tab>
      </div>
      <div class="row" style="margin-bottom:50px;">
        <ng-container *ngIf="(activeSideTab$ | async) === 'innovation_activity'">
          <app-innovation-activity [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [search_type]="(getParams() | async)?.search_type || null">
          </app-innovation-activity>

        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'tech_footprint'">
          <app-technology-footprint [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [search_type]="(getParams() | async)?.search_type || null">
          </app-technology-footprint>
        </ng-container>




        <ng-container *ngIf="(activeSideTab$ | async) === 'innovation_quality'">
          <app-innovation-quality [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-innovation-quality>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_public_competitors'">
          <app-thematic-public-competitors [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-thematic-public-competitors>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_custom_peer_group'">
          <app-thematic-competition-overview [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-thematic-competition-overview>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'company_private_competitors'">
          <app-private-competitors  [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [side_nav_name]="'competitive_benchmarking_peergroup'">
          </app-private-competitors>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'company_public_competitors'">
          <app-public-competitors  [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [side_nav_name]="'company_public_competitors'">
          </app-public-competitors>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_private_competitors'">
          <app-thematic-private-competitors
            [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" >
          </app-thematic-private-competitors>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'competitive_benchmarking_peergroup'">
          <app-company-overview [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [entity_data]="null"
            [side_nav_name]="'competitive_benchmarking_peergroup'">
          </app-company-overview>
        </ng-container>


        <ng-container *ngIf="(activeSideTab$ | async) === 'executive_summary'">
          <app-company-overview [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [entity_data]="(getParams() | async)?.params?.entity_data || null" [side_nav_name]="'executive_summary'">
          </app-company-overview>
        </ng-container>



        <!--MARK: Inventions View-->
        <ng-container *ngIf="(activeSideTab$ | async) === 'inventions_view'">
          <app-inventions-view [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-inventions-view>
        </ng-container>


        <!--MARK: Clustering  -->

        <ng-container *ngIf="(activeSideTab$ | async) === 'clustering_innovation_activity'">
          <app-clustering-innovation-activity [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-clustering-innovation-activity>
        </ng-container>


        <ng-container *ngIf="(activeSideTab$ | async) === 'clustering_peer_group'">
          <app-clustering-peer-group [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-clustering-peer-group>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'clustering_tech_footprint'">
          <app-clustering-tech-footprint [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-clustering-tech-footprint>
        </ng-container>


        <ng-container *ngIf="(activeSideTab$ | async) === 'cluster_treemap'">
          <app-cluster-treemap [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [qipHighlights]="false">
          </app-cluster-treemap>
        </ng-container>


      </div>

    </div>
  </div>
</div>
<router-outlet></router-outlet>